import { useAtom } from 'jotai';
import { useMemo } from 'react';

import TableWidget from '@/components/TableWidget';
import { PAGE_SIZES } from '@/constants/common';
import useStyles from '@/pages/Announcements/Announcement.styles';
import { publishedAnnouncementsAtom } from '@/pages/Announcements/Announcements.store';
import { isLayoutMobileAtom } from '@/store/layout';
import { isSidebarExpandedAtom } from '@/store/sidebar';

import useAnnouncements from '../Announcement.hooks';
import useAnnouncementDialog from '../AnnouncementDialog/AnnouncementDialog.hooks';
import { createColumns } from '../Announcements.utils';

const PublishedAnnouncements = () => {
  const { classes } = useStyles();
  const [publishedAnnouncements] = useAtom(publishedAnnouncementsAtom);
  const [isLayoutMobile] = useAtom(isLayoutMobileAtom);
  const [isSidebarExpanded] = useAtom(isSidebarExpandedAtom);

  const { userIsInternal, setSelectedAnnouncement } = useAnnouncements();
  const { setOpen, setType } = useAnnouncementDialog();

  const columns = useMemo(
    () =>
      createColumns(
        classes,
        userIsInternal,
        setOpen,
        setSelectedAnnouncement,
        setType,
        'published'
      ),
    [userIsInternal]
  );

  const width = useMemo(() => {
    // mobile
    if (isLayoutMobile) return '100%';
    // desktop
    if (isSidebarExpanded) return 'calc(100vw - 21.5rem)';
    return 'calc(100vw - 7rem)';
  }, [isLayoutMobile, isSidebarExpanded]);

  return (
    <div
      style={{
        height: '100%',
        width
      }}
    >
      <TableWidget
        title="Announcements"
        columns={columns}
        rows={publishedAnnouncements}
        loading={false}
        header
        pageSizeOptions={PAGE_SIZES}
        disableRowSelectionOnClick
      />
    </div>
  );
};

export default PublishedAnnouncements;
